"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerConfigurationSchemaV2 = exports.routerConfigurationSchema = exports.routerConfigurationSchemaBase = exports.routeSchemaV2 = exports.routeSchema = exports.routeIdempotencySchema = exports.routeRateLimitsSchema = exports.routeAuthenticationSchemaV2 = exports.routeAuthenticationSchema = exports.routeStatsSchema = exports.routeVersionSchema = exports.hostSchema = void 0;
const zod_1 = require("zod");
const Auth_1 = require("./Auth");
const Decorators_1 = require("./Decorators");
exports.hostSchema = zod_1.z.string();
exports.routeVersionSchema = zod_1.z.array(zod_1.z.string());
exports.routeStatsSchema = zod_1.z
    .object({
    domain: zod_1.z.string(),
    subDomain: zod_1.z.string(),
    action: zod_1.z.string(),
    importance: zod_1.z.nativeEnum(Decorators_1.StatsImportance).optional(),
    tags: zod_1.z.record(zod_1.z.string().optional()).optional(),
})
    .strict();
exports.routeAuthenticationSchema = zod_1.z.record(zod_1.z.nativeEnum(Auth_1.AuthType), zod_1.z.array(zod_1.z.string()));
exports.routeAuthenticationSchemaV2 = zod_1.z.array(zod_1.z.record(zod_1.z.nativeEnum(Auth_1.AuthType), zod_1.z.array(zod_1.z.string())));
exports.routeRateLimitsSchema = zod_1.z.object({
    points: zod_1.z.number().optional(),
    duration: zod_1.z.number().optional(),
});
exports.routeIdempotencySchema = zod_1.z.object({
    ttl: zod_1.z.number().optional(),
});
exports.routeSchema = zod_1.z
    .object({
    path: zod_1.z.string(),
    method: zod_1.z.union([
        zod_1.z.literal("get"),
        zod_1.z.literal("post"),
        zod_1.z.literal("put"),
        zod_1.z.literal("delete"),
        zod_1.z.literal("options"),
        zod_1.z.literal("head"),
        zod_1.z.literal("patch"),
    ]),
    authentication: exports.routeAuthenticationSchema.optional(),
    stats: exports.routeStatsSchema.optional(),
    versions: exports.routeVersionSchema.optional(),
    rateLimits: exports.routeRateLimitsSchema.optional(),
    idempotentcy: exports.routeIdempotencySchema.optional(),
    requireAccount: zod_1.z.boolean().optional(),
})
    .strict();
exports.routeSchemaV2 = zod_1.z
    .object({
    path: zod_1.z.string(),
    method: zod_1.z.union([
        zod_1.z.literal("get"),
        zod_1.z.literal("post"),
        zod_1.z.literal("put"),
        zod_1.z.literal("delete"),
        zod_1.z.literal("options"),
        zod_1.z.literal("head"),
        zod_1.z.literal("patch"),
    ]),
    authentication: exports.routeAuthenticationSchemaV2.optional(),
    stats: exports.routeStatsSchema.optional(),
    versions: exports.routeVersionSchema.optional(),
    rateLimits: exports.routeRateLimitsSchema.optional(),
    idempotentcy: exports.routeIdempotencySchema.optional(),
    requireAccount: zod_1.z.boolean().optional(),
})
    .strict();
exports.routerConfigurationSchemaBase = zod_1.z.object({
    version: zod_1.z.union([zod_1.z.literal(1), zod_1.z.literal(2)]).optional(),
});
exports.routerConfigurationSchema = exports.routerConfigurationSchemaBase
    .extend({
    version: zod_1.z.literal(1).optional(),
    name: zod_1.z.string(),
    hostStaging: exports.hostSchema,
    hostProd: exports.hostSchema,
    routes: zod_1.z.array(exports.routeSchema),
})
    .strict();
exports.routerConfigurationSchemaV2 = exports.routerConfigurationSchemaBase
    .extend({
    version: zod_1.z.literal(2),
    name: zod_1.z.string(),
    hostStaging: exports.hostSchema,
    hostProd: exports.hostSchema,
    routes: zod_1.z.array(exports.routeSchemaV2),
})
    .strict();
//# sourceMappingURL=Router.js.map